export default {"src":"/_next/static/media/about.e2d31820.svg","height":783,"width":1022,"blurWidth":0,"blurHeight":0};